import config from '../config'
import services from './services'
import locales from 'core/i18n'

import ecommerceService from './services/ecommerce'
import coreService from './services/core'
import envService from './services/env'
import httpService from './services/http'
import storageService from './services/storage'
import translationService from './services/translation'
import utilsService from './services/utils'
// import 'moment/locale/fa'
// import 'moment/locale/en-au'

services.debug = process.env.NODE_ENV === 'development'

// Environment service
// Note: Most be top of other services
services.register('env', envService, { resources: config, defaultNS: 'app' })

// Storage service
services.register('storage', storageService)

// Utils service
services.register('utils', utilsService)

// HTTP service
services.register('http', httpService)

// Ecommerce service
services.register('ecommerce', ecommerceService, {
  getToken() {
    // console.log('get token called in bootstrap.js')
    // console.log('baseURL:', services.env.get('http:ecommerce.baseURL'))
    const token = services.storage.get('customer_token') || services.storage.get('device_token');
    return 'Bearer ' + token
  },
  baseURL: services.env.get('http:ecommerce.baseURL'),
  hasMock: services.env.get('http:ecommerce.mock.enabled'),
  mockDelay: services.env.get('http:ecommerce.mock.delay')
})

if (!services.storage.get('language')) {
  services.storage.set('language', 'fa')
}

// Register translation service
services.register('translation', translationService, {
  lng: services.storage.get('language'),
  onLanguageChanged: (lng = 'fa') => {
    services.storage.set('language', lng)
    window.location.reload()
  },
  defaultNS: 'common',
  resources: locales
})

// Core service registration
services.register('core', coreService)
